const prefix = 'CONTROL_INFO';

export const GET_RECIPE_GROUPS_LOADING = `${prefix}_GET_RECIPE_GROUPS_LOADING`;
export const GET_RECIPE_GROUPS_SUCCESS = `${prefix}_GET_RECIPE_GROUPS_SUCCESS`;
export const GET_RECIPE_GROUPS_ERROR = `${prefix}_GET_RECIPE_GROUPS_ERROR`;

export const WRITE_RECIPE_GROUPS_LOADING = `${prefix}_WRITE_RECIPE_GROUPS_LOADING`;
export const WRITE_RECIPE_GROUPS_SUCCESS = `${prefix}_WRITE_RECIPE_GROUPS_SUCCESS`;
export const WRITE_RECIPE_GROUPS_ERROR = `${prefix}_WRITE_RECIPE_GROUPS_ERROR`;

export const DELETE_RECIPE_GROUP_LOADING = `${prefix}_DELETE_RECIPE_GROUP_LOADING`;
export const DELETE_RECIPE_GROUP_SUCCESS = `${prefix}_DELETE_RECIPE_GROUP_SUCCESS`;
export const DELETE_RECIPE_GROUP_ERROR = `${prefix}_DELETE_RECIPE_GROUP_ERROR`;

export const CLEAR_ERROR = `${prefix}_CLEAR_ERROR`;



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/recipeGroup/types.js